
import { trackModals } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalOdfPromo',

    data() {
        return {
            promoImage: require('~assets/images/events/odf-pop-up-modal-2026.avif'),
        }
    },

    computed: {
        titleText() {
            return this.$t('odf_promo_modal.title', {
                amount: this.$n(50, 'currency-no-decimal'),
            })
        },
        bodyText() {
            return this.$t('odf_promo_modal.body', {
                minOrderValue: this.$n(300, 'currency-no-decimal'),
            })
        },
        ctaUrl() {
            return `${this.$config.appUrl}/marketplace?modal=odf-promo`
        },
    },

    methods: {
        handleCtaClick() {
            trackModals('odfCtaClicked')
            EventBus.$emit('modal-close')
        },
    },
}
